<template>
    <div class="search-company__container">
        <div
            v-click-outside="hideDropdown"
            class="dropdown"
            :class="{ 'dropdown-active': dropdownActive }"
        >
            <form-input
                v-model="form.value"
                :placeholder="'Enter your EIN to lookup your business'"
                :hideLabelColon="true"
                autocomplete="off"
                formatter="EIN"
                :error="form.errors.get('message')"
                @focus="showDropdown"
                @input="searchProcess"
                @keydown="handleKeydown"
            />
        </div>
        <div
            v-if="result.length || emptyMessage.length"
            class="search-company__dropdown selectize-dropdown single"
            :class="{
                'dropdown-active': dropdownActive,
                'search-company__relative-dropdown': isRelativeDropdown,
            }"
        >
            <div class="selectize-dropdown-content">
                <div v-if="emptyMessage.length" class="empty">
                    {{ emptyMessage }}
                </div>
                <template v-else>
                    <div
                        v-for="(item, i) in result"
                        :key="`result-${i}`"
                        class="option"
                        @click="select(item)"
                    >
                        <span class="name"> {{ item.name }} </span><br />
                        {{ item.street1 }}, {{ item.city }}, {{ item.state }}, {{ item.zip }}<br />
                        EIN: {{ item.ein_formatted }}
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import Form from 'core/Form';
import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    directives: {
        ClickOutside,
    },

    props: {
        label: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        icon: { type: String, default: '' },
        isRelativeDropdown: { type: Boolean, default: false },
    },

    data() {
        return {
            form: new Form(
                {
                    value: '',
                },
                false,
                true
            ),
            busy: false,
            result: [],
            loading: false,
            emptyMessage: '',
            dropdownActive: false,
        };
    },

    computed: {
        ...mapState(stores.ComplianceProfile, ['isBPVerifyEinLoading']),
        ...mapState(stores.DLCProfile, ['isDlsVerifyEinLoading']),
    },

    watch: {
        'form.value'(value) {
            this.resetState();
        },

        isDlsVerifyEinLoading(status) {
            if (status) {
                this.resetState();
            }
        },
    },

    methods: {
        async searchProcess(value) {
            this.resetState();
            this.busy = true;

            await this.$store.dispatch('fetchBusinessProfileVerifyEin', value).then((res) => {
                if (res && res.status === 404) {
                    this.result = [];
                    this.emptyMessage = res.data.message;
                    this.form.errors.clear();
                    this.showDropdown();

                    return;
                }

                if (res && res.status === 422) {
                    this.result = [];
                    this.emptyMessage = '';
                    if (res.data.message === 'The q field is required.') {
                        this.form.errors.clear();
                    } else {
                        this.form.errors.record({ message: [res.data.message] });
                    }

                    return;
                }

                if (res && typeof res === 'object' && typeof res.data === 'object') {
                    this.result = res.data;
                    this.emptyMessage = '';
                    this.form.errors.clear();
                    this.showDropdown();
                }
            });
        },

        async select(item) {
            this.$emit('select', item);
            this.hideDropdown();
        },

        showDropdown() {
            this.dropdownActive = true;

            // Use after press Keydown 88
            if (
                !this.result.length &&
                !this.emptyMessage &&
                !this.form.errors.get('message') &&
                this.form.value
            ) {
                this.searchProcess(this.form.value);
            }
        },

        hideDropdown() {
            this.dropdownActive = false;
        },

        handleKeydown({ e }) {
            if (e.keyCode === 88) {
                this.resetState();
            }
        },

        resetState() {
            this.result = [];
            this.emptyMessage = '';
            this.form.errors.clear();
        },
    },
};
</script>

<style lang="scss" scoped>
.search-company {
    &__container {
        position: relative;
        .dropdown {
            &.dropdown-active {
                .field {
                    .input:focus,
                    .input.is-focused,
                    .input:active,
                    .input.is-active,
                    input {
                        border-radius: 3px 3px 0 0;
                        box-shadow: none;
                        &:focus {
                            box-shadow: none;
                        }
                    }
                }
            }

            .field {
                margin-bottom: 0;
            }
        }
        .subtext {
            display: flex;
            color: #7f7f7f;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: -0.154px;
            margin-top: 6px;
        }
    }
    &__relative-dropdown {
        position: relative;
        .empty {
            color: #7f7f7f;
            font-size: 13px;
            font-weight: 400;
            padding: 10px;
        }
    }
    &__dropdown {
        width: 100%;
        display: none;
        border-top: 1px solid #d0d0d0;
        &.dropdown-active {
            display: block;
            border-color: #1d96f3;
            border-top: 1px solid #efefef;
        }
        .option {
            display: block;
            cursor: pointer;
            padding: 8px 10px;
            color: #7f7f7f;
            font-size: 13px;
            font-weight: 400;
            letter-spacing: -0.078px;
            &:hover {
                background-color: #f5fafd;
                color: #495c68;
            }
            .name {
                color: #363636;
            }
        }
    }
}
</style>
